.count {
    display: flex;
}

.icon {
    margin-top: 2px; /* This centers the icon vertically */
    padding-right: 4px;
}
